
    import { Component, Prop, Vue } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';

    @Component({
        methods: {
            ...mapActions('patient', ['addAgainToWarteliste']),
        },
    })
    export default class DialogAddAgainToWarteliste extends Vue {
        @Prop() visible!: boolean;
    }
